import { Box, Checkbox, Chip, FormControlLabel, Radio, Stack, Typography } from '@mui/material';
import { colorTokens, radiusTokens, typographyTokens } from '../../app/designTokens';
import { selectableCardSx } from './registerSurfaces';

const { semantic } = colorTokens;

/**
 * Figma Base: selectable card used by ModuleCard, UserTierCard,
 * BillingPeriodCard and AdditionalServiceCard.
 */
export function SelectableOptionCard({
  control = 'checkbox',
  selected = false,
  disabled = false,
  onSelect,
  value,
  title,
  description,
  badge,
  trailing,
  testId,
  inputTestId,
}) {
  const isRadio = control === 'radio';
  const ControlComponent = isRadio ? Radio : Checkbox;
  const controlProps = isRadio
    ? { value, checked: selected }
    : { checked: selected, onChange: onSelect };

  return (
    <FormControlLabel
      data-testid={testId}
      data-selected={selected ? 'true' : 'false'}
      disabled={disabled}
      value={isRadio ? value : undefined}
      sx={selectableCardSx(selected)}
      control={(
        <ControlComponent
          size="small"
          disabled={disabled}
          sx={{ p: 0.5, color: semantic.text.muted }}
          inputProps={inputTestId ? { 'data-testid': inputTestId } : undefined}
          {...controlProps}
        />
      )}
      label={(
        <Box sx={{ width: '100%' }}>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="space-between"
            flexWrap="wrap"
            useFlexGap
          >
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
              <Typography
                sx={{
                  fontFamily: typographyTokens.fontFamily,
                  fontWeight: typographyTokens.fontWeightSemibold,
                  fontSize: 14,
                  color: semantic.text.primary,
                }}
              >
                {title}
              </Typography>
              {badge ? (
                <Chip
                  size="small"
                  label={badge}
                  sx={{
                    height: 20,
                    borderRadius: `${radiusTokens.chip}px`,
                    bgcolor: semantic.status.neutral.bg,
                    color: semantic.status.neutral.text,
                    border: `1px solid ${semantic.border.subtle}`,
                    fontSize: 11,
                  }}
                />
              ) : null}
            </Stack>
            {trailing ? (
              <Typography sx={{ fontSize: 13, color: semantic.text.secondary }}>
                {trailing}
              </Typography>
            ) : null}
          </Stack>
          {description ? (
            <Typography sx={{ fontSize: 12, color: semantic.text.muted, mt: 0.25 }}>
              {description}
            </Typography>
          ) : null}
        </Box>
      )}
    />
  );
}

export default SelectableOptionCard;
